import React from "react";
import {
  Coins,
  Wallet,
  TrendingDown,
  Zap,
  Globe2,
  ShieldCheck,
  Users,
  BarChart3,
} from "lucide-react";

const items = [
  { icon: Coins, title: "Capital de giro imediato", desc: "Liquidez para acelerar operações e oportunidades." },
  { icon: Wallet, title: "Reforço de caixa empresarial", desc: "Estabilidade financeira para crescimento sustentável." },
  { icon: TrendingDown, title: "Juros reduzidos", desc: "Custo financeiro inferior ao mercado tradicional." },
  { icon: Zap, title: "Aprovação rápida", desc: "Processo ágil, sem burocracia desnecessária." },
  { icon: Globe2, title: "Atendimento nacional", desc: "Operações estruturadas em todo o Brasil." },
  { icon: ShieldCheck, title: "Segurança contratual", desc: "Validação documental e respaldo jurídico completo." },
  { icon: Users, title: "Empresas e Pessoa Física", desc: "Soluções sob medida para cada perfil estratégico." },
  { icon: BarChart3, title: "Alto poder de crédito", desc: "Cartas contempladas de valores expressivos." },
];

export default function Benefits() {
  return (
    <section
      id="beneficios"
      data-testid="benefits-section"
      className="relative bg-[#0B101A] py-24 md:py-36 overflow-hidden"
    >
      {/* gold faint accent */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] opacity-15 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse, rgba(212,175,55,0.4) 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-4 mb-6">
            <div className="gold-line" />
            <span className="overline">Benefícios</span>
          </div>
          <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-[3.5rem] font-light leading-[1.05] tracking-[-0.015em]">
            Vantagens estratégicas para{" "}
            <span className="text-[#D4AF37] italic">acelerar resultados</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#D4AF37]/10">
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`benefit-card-${i}`}
              className="group bg-[#0B101A] hover:bg-[#11172A] p-8 md:p-10 transition-all duration-500 cursor-default"
            >
              <it.icon
                size={28}
                strokeWidth={1.2}
                className="text-[#D4AF37] mb-7 group-hover:scale-110 transition-transform duration-500"
              />
              <h3 className="font-serif-ag text-white text-xl md:text-2xl font-medium leading-tight mb-3">
                {it.title}
              </h3>
              <p className="text-[#A3ABB8] text-sm leading-relaxed font-light">
                {it.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
